import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Shards } from '#src/atoms/icons/Shards.tsx';
import type { unitMapping } from '#src/lib/style.ts';
import { useGetRarityShardColor } from '#src/set/index.ts';

type Props = {
  cardSetSlug?: string | null;
  size?: keyof typeof unitMapping;
  className?: string;
  gradient?: 'purple';
};
export const CommonShards = ({
  cardSetSlug,
  size = 2,
  className,
  gradient,
}: Props) => {
  const getRarityShardColor = useGetRarityShardColor();
  const shardColor = getRarityShardColor(Rarity.common, cardSetSlug);
  return (
    <Shards
      color={shardColor}
      size={size}
      className={className}
      gradient={gradient}
    />
  );
};
